import { FC } from "react";

const A11yH1: FC<React.PropsWithChildren<unknown>> = ({ children }) => <h1 className="w-0 h-0 overflow-hidden">{children}</h1>;

export default A11yH1;
